import {
	CalendarDaysIcon,
	ClockIcon,
	MapPinIcon,
	SparklesIcon,
	TicketIcon,
} from '@heroicons/react/20/solid'

export default function AnnualProductionRoute() {
	return (
		<main>
			<div className="relative isolate overflow-hidden bg-stone-900">
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="mx-auto mt-24 max-w-7xl px-6 pb-24 pt-10 sm:pb-32 lg:mt-0 lg:flex lg:items-center lg:px-8 lg:py-40">
					<div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl lg:lg:pt-8">
						<div className="inline-flex space-x-3">
							<span className="rounded-full bg-stone-100/10 px-3 py-1 text-sm font-semibold leading-6 text-stone-100">
								35th Season
							</span>
							<span className="inline-flex items-center space-x-2 text-sm font-medium leading-6 text-stone-300">
								<span>2026-27</span>
							</span>
						</div>
						<h3 className="mt-6 text-4xl font-extrabold uppercase leading-6 tracking-wide text-white md:text-6xl lg:text-7xl xl:text-8xl">
							<span className="text-[#f9c04d]">Annual</span>
							{/* <span className="text-[#f9c04d]">.</span> */}
						</h3>
						<h3 className="text-4xl font-extrabold uppercase tracking-wide text-white md:text-6xl lg:text-7xl xl:text-8xl">
							Production
						</h3>

						<p className="text-3xl font-extrabold leading-6 text-[#f9c04d] md:text-4xl lg:mr-24 lg:text-right xl:mr-0">
							celebrate with us
							<span className="text-stone-100">.</span>
						</p>
					</div>
					<div className="mx-auto mt-16 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32">
						<div className="max-w-3xl flex-none sm:max-w-5xl lg:max-w-none">
							<div className="-m-2 rounded-xl bg-[#f9c04d] p-2 ring-1 ring-inset ring-[#f9c04d] lg:-m-4 lg:rounded-2xl lg:p-4">
								<img
									src="/images/registration-now.jpg"
									alt="Studio Students"
									width={2432}
									height={1442}
									className="w-[56rem] rounded-md shadow-2xl ring-1 ring-gray-900/10"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="relative isolate overflow-hidden border-t-2 border-stone-800 bg-stone-900 pb-32">
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="mx-auto max-w-7xl px-6 py-24 lg:px-8">
					<div className="md:grid md:grid-cols-6 md:items-start md:justify-start">
						<div className="pb-8 text-4xl font-extrabold text-stone-50 md:col-span-2 md:pb-0 md:text-6xl lg:text-7xl xl:text-8xl">
							Join <span className="text-[#f9c04d]">us</span>.
						</div>
						<div className="space-y-4 text-lg font-semibold tracking-wide text-stone-200 md:col-span-4">
							<p>
								Join us in celebrating our 35th Annual Production this season!
							</p>
							<p>
								We encourage all of our dancers to participate in our Annual
								Dance Production. We believe the discipline of dance training
								gives children a better understanding of commitment by offering
								them the chance to learn, experience the spirit of teamwork, and
								understand what hard work can accomplish. A performance always
								creates wonderful memories for your dancer and family!
							</p>
						</div>
					</div>
				</div>
				<div className="mx-auto mt-3 w-full max-w-3xl space-y-6 px-6 sm:grid sm:grid-cols-2 sm:justify-end sm:gap-x-8 sm:gap-y-8 sm:space-y-0">
					<div className="rounded-lg border border-[#f9c04d] p-6 text-stone-100">
						<div className="flex items-center">
							<CalendarDaysIcon className="mr-2 inline-block h-6 w-6 text-[#f9c04d]" />
							<h3 className="text-2xl font-extrabold uppercase tracking-widest text-[#f9c04d]">
								Date
							</h3>
						</div>
						<ul>
							<li className="mt-4 text-base">
								Dress Rehearsal: TBD
							</li>
							<li className="mt-4 text-base">
								Show Day: TBD
							</li>
						</ul>
					</div>
					<div className="rounded-lg border border-[#f9c04d] p-6 text-stone-100">
						<div className="flex items-center">
							<ClockIcon className="mr-2 inline-block h-6 w-6 text-[#f9c04d]" />
							<h3 className="text-2xl font-extrabold uppercase tracking-widest text-[#f9c04d]">
								Time
							</h3>
						</div>
						<ul>
							<li className="mt-4 text-base">Show 1 - TBD</li>
							<li className="mt-4 text-base">Show 2 - TBD</li>
							<li className="mt-4 text-base">Show 3 - TBD</li>
						</ul>
					</div>
					<div className="rounded-lg border border-[#f9c04d] p-6 text-stone-100">
						<div className="flex items-center">
							<MapPinIcon className="mr-2 inline-block h-6 w-6 text-[#f9c04d]" />
							<h3 className="text-2xl font-extrabold uppercase tracking-widest text-[#f9c04d]">
								Location
							</h3>
						</div>
						<ul>
							<li className="mt-4 text-base">TBD</li>
						</ul>
					</div>
					<div className="rounded-lg border border-[#f9c04d] p-6 text-stone-100">
						<div className="flex items-center">
							<TicketIcon className="mr-2 inline-block h-6 w-6 text-[#f9c04d]" />
							<h3 className="text-2xl font-extrabold uppercase tracking-widest text-[#f9c04d]">
								Tickets
							</h3>
						</div>
						<div>
							<p className="mt-4 text-base">TBD</p>
						</div>
					</div>
					<div className="col-span-2 rounded-lg border border-[#f9c04d] p-6 text-stone-100">
						<div className="flex items-center">
							<SparklesIcon className="mr-2 inline-block h-6 w-6 text-[#f9c04d]" />
							<h3 className="text-2xl font-extrabold uppercase tracking-widest text-[#f9c04d]">
								Costumes
							</h3>
						</div>
						<p className="py-6">
							Stage Door Dance Academy prides itself with beautiful,
							age-appropriate and on-time arrival of costumes. Students
							performing in the Annual Production are required to purchase
							costumes for the performance.
						</p>
					</div>
				</div>
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
			</div>
		</main>
	)
}
